<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ecg"
          label="ECG"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ecocardio"
          label="Ecocardio"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.vasosDeCuello"
          label="Vasos de cuello"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.peg"
          label="PEG"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.mapa"
          label="Mapa"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.holter"
          label="Holter"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.doppler"
          label="Doppler"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.ccg"
          label="CCG"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <v-text-field
          v-model="values.spect"
          label="SPECT"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="values.otrosEstudios"
          label="Otros Estudios"
          prepend-icon="mdi-hospital"
          dense
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import evolucionJsonMixin from "../../../../mixins/evolucionJsonMixin";
export default {
  data() {
    return {
      values: {
        ecg: null,
        ecocardio: null,
        vasosDeCuello: null,
        peg: null,
        mapa: null,
        holter: null,
        doppler: null,
        ccg: null,
        spect: null,
        otrosEstudios: null,
      },
    };
  },
  mixins: [evolucionJsonMixin],
  computed: {
    camposRequeridos() {
      return false;
    },
    defaultValues() {
      return {
        ecg: null,
        ecocardio: null,
        vasosDeCuello: null,
        peg: null,
        mapa: null,
        holter: null,
        doppler: null,
        ccg: null,
        spect: null,
        otrosEstudios: null,
      };
    },
  },
  created() {
    if (!this.evolucionJson) {
      this.values = { ...this.defaultValues };
    }
  },
};
</script>
